export default __webpack_public_path__ + "static/media/Wavis_Logo_Dark.fafbdcc1.png";